export default {
	field: 'productClass.categoryName',
	name: 'Category',
}
